<template>
  <div>
    <Head :title="title" />
    <div class="max-w-3xl overflow-hidden bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
            <!-- <select-input v-if="!form.parent_id" v-model="form.department_id" :error="form.errors.department_id" class="w-full pb-8 pr-6" :label="__('Department')">
                <option :value="null">None</option>
                <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
            </select-input>
            <select-input v-if="!form.department_id" v-model="form.parent_id" :error="form.errors.parent_id" class="w-full pb-8 pr-6" :label="__('Parent')">
                <option :value="null">None</option>
                <option v-for="s in categories" :key="s.id" :value="s.id">{{ s.name }}</option>
            </select-input> -->
          <text-input v-model="form.name" :error="form.errors.name" class="w-full pb-8 pr-6 " label="Name" />
<!--          <text-input v-model="form.color" :error="form.errors.color" class="w-full pb-8 pr-6 lg:w-1/2 color-picker" label="Color" />-->
        </div>
        <div class="flex items-center justify-end px-8 py-4 border-t border-gray-100 bg-gray-50">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Créer une categorie</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link, Head } from '@inertiajs/vue3'
import SelectInput from "../../Shared/SelectInput.vue";

export default {
  metaInfo: { title: 'Create Category' },
  components: {
      SelectInput,
    LoadingButton,
    TextInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
      title: String,
      categories: { required: false },
      departments: { required: false },
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
          parent_id: null,
        department_id: null,
        color: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('categories.store'))
    },
  },
}
</script>
